module.exports = __webpack_public_path__ + "media/Components/fonts/Bitteritalic-b934676628be144fdfade92ad5b8767a.ttf";